<div class="container-fluid container-fluid-wrap container-fluid-wrap-preview" 
   [ngClass]="{
   'preview-wrap-fullscreen': fullScreen
   }"
   [class.link]="item.context === 'link' || item.context === 'applink'"

   >
   <div class="preview-wrap preview-wrap-no-overflow" [ngClass]="{'loading-state': !initialized}">
      <div
         *ngIf="fullScreen"
         class="fullscreen-name"
         >
         {{items.current.name}}
      </div>
      <div
      *ngIf="fullScreen"
      class="fullscreen-close-icon"
      (click)="fullScreen = !fullScreen"
      >
      <sync-icon name="close"></sync-icon>
   </div>
   <app-error *ngIf="errcode" [errcode]="errcode"></app-error>
   <div class="preview-wrap-icon">
      <div class="preview-wrap-icon-inner">
         <img 
         *ngIf="transferView?.single?.renderFile?.dl_ready && !item?.previewonly && initialized" 
         [src]="imageURL"
         class="preview-wrap-img img-responsive"
         [ngClass]="{'preview-wrap-img-fullscreen' : fullScreen }"/>
         <div *ngIf="!initialized" class="preview-loading-wrap">
            <sync-spinner></sync-spinner>
         </div>
         <div class="placeholder"></div>
         <div *ngIf="canShowImageNav && items.amount > 1"
            class="preview-image-nav"
            [ngClass]="{
            'preview-image-nav-fullscreen': fullScreen
            }"
            >
            <sync-icon-button iconName="chevron-left" [onClick]="navigatePrev"></sync-icon-button>
            <div class="preview-image-nav-count">
               {{items.idx}} of {{items.amount}}
            </div>
            <sync-icon-button iconName="chevron-right" [onClick]="navigateNext"></sync-icon-button>
            <sync-icon-button 
            [iconName]="!fullScreen ? 'fullscreen-mode' : 'exit-fullscreen-mode'" 
            [matTooltip]="!fullScreen ? 'Presentation mode' : 'Exit presentation mode'" 
            matTooltipClass='presentation-tooltip'
            [onClick]="toggleMode">
            </sync-icon-button>
         </div>
      </div>
   </div>
</div>
</div>